import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import validation from './validation';

export function getUploadColumns() {
    const { parsedFile, allChecked, validationError } = this.state;

    function toggleWarning(viewIndex){
        let info = document.querySelector(`.warning-info-${viewIndex}`)
        if(info.style.visibility == 'hidden'){
            info.style.visibility = 'visible'
            info.focus()
        }else{
            info.style.visibility = 'hidden'
        }
    }
    
    return [{
        Header: 'Particulars of Parent/Legal Guardian',
        columns: [{
            Header: (
                <input
                    type="checkbox"
                    checked={allChecked}
                    disabled={validationError}
                    onChange={(e) => {
                        const newParsedFile = parsedFile.map(o => ({
                            ...o,
                            uploadStatus: o.uploadStatus === 2 ? o.uploadStatus : (e.target.checked ? 1 : 0),
                        }));
                        this.setState({
                            parsedFile: newParsedFile,
                            allChecked: e.target.checked,
                        });
                    }}
                />
            ),
            width: 80,
            Cell: cell => (
                <p key={`no${cell.viewIndex}`} style={{ textAlign: 'center' }}>
                    {
                        cell.row._original.validationError ? 
                        <div class="warning-container">
                            <button class="icon-big icon-warning text-center warning-button" style={{fontSize: '2em', }} 
                                onClick={() => toggleWarning(cell.viewIndex)} 
                                onBlur={()=> toggleWarning(cell.viewIndex)}>
                                !
                            </button>
                            <div class={`warning-info warning-info-${cell.viewIndex}`} style={{visibility: "hidden"}}>
                                {cell.row._original.validationError.map((error,i) => 
                                    <div key={i} class="error-card">
                                        {
                                            error.category === "nricError" ? 
                                            <span class="title">Error:{' '}
                                                {error.type === "duplicate" ? 
                                                    error.duplicate === "multi-line" ?
                                                        `Duplicated ${error.column && error.column.split('.')[0] === 'Beneficiary' ? "Beneficiary" : "Applicant"} ID Number`
                                                        : 'Duplicated ID Number'
                                                    : `${error.column && error.column.split('.')[0] === 'Beneficiary' ? "Beneficiary" : "Applicant"} ID Number`
                                                }
                                            </span> 
                                            : <span class="title">Error: {error.column && error.column.split('__c')[0].split('_').join(' ').split('.').join(' - ')}</span>
                                        }
                                        {error.type === "duplicate" ? 
                                            <p>
                                                {
                                                    error.duplicate === "multi-line" ? 
                                                    `Beneficiary’s ID number is duplicated with another beneficiary’s ID number ` : 
                                                    `Applicant and beneficiary’s ID number are duplicated `
                                                }
                                            </p> :   
                                            // <span class="subtitle">column: {error.column && error.column.split('__c')[0].split('_').join(' ').split('.').join(' - ')}</span>
                                            <p class="subtitle">{validation.errorMessage[error.category][error.type]}</p>
                                        }
                                        {/* {error.type !== "duplicate" &&
                                            <p>{validation.errorMessage[error.category][error.type]}</p>
                                        } */}
                                    </div>)
                                }
                                
                            </div>
                        </div> : cell.row._original.uploadStatus === 2 ? 
                        (
                            <Link to={`/portal/application/${cell.row._original.sfId}`} target="_blank">
                                {cell.row._original.sfId}
                            </Link>
                        )
                        : (
                            <input
                                type="checkbox"
                                checked={cell.row._original.uploadStatus === 1}
                                // className="form-control"
                                disabled={cell.row._original.uploadStatus === 2}
                                key={`chk${cell.viewIndex}`}
                                onChange={(e) => {
                                    parsedFile[cell.index] = {
                                        ...parsedFile[cell.index],
                                        uploadStatus: e.target.checked ? 1 : 0,
                                    };
                                    this.setState(parsedFile);
                                }}
                            />
                        )
                    }
                    
                </p>
            ),
        }, {
            Header: "Parent’s/Legal Guardian's Full Name (in NRIC/FIN)",
            accessor: 'Full_Name__c',
        }, {
            Header: 'Address',
            accessor: 'Street__c',
            Cell: cell => (
                <p>
                    {cell.value}<br />
                    {cell.row._original.Block__c} {cell.row._original.Unit_Number__c} <br />
                    {cell.row._original.Country__c}, <br />
                    {cell.row._original.Postal_Code__c}
                </p>
            ),
        }, {
            Header: 'Date Of Birth',
            accessor: 'Date_of_Birth__c',
            // Cell: cell => cell.value.format('DD-MMM-YYYY'),
        }, {
            Header: 'Nationality',
            accessor: 'Nationality__c',
        }, {
            Header: 'Marital Status',
            accessor: 'Marital_Status__c',
        }, {
            Header: 'Type of Housing',
            accessor: 'Flat_Type__c',
        }],
    }, {
        Header: 'Particulars Students',
        columns: [{
            Header: <p>Student’s Full Name <br />(in NRIC / Birth Certificate)</p>,
            accessor: 'beneficiary.Full_Name__c',
        }, {
            Header: 'NRIC/FIN',
            accessor: 'beneficiary.ID_Number__c',
            Cell: cell => (
                <p>
                    {cell.value}
                </p>
            ),
        }, {
            Header: 'DOB',
            accessor: 'beneficiary.Date_of_Birth__c',
            Cell: cell => moment(cell.value).format('DD-MMM-YYYY'),
        }, {
            Header: 'Student Nationality',
            accessor: 'beneficiary.Nationality__c',
        }, {
            Header: 'Level',
            accessor: 'beneficiary.Current_Level__c',
        }, {
            Header: 'Year Of Study',
            accessor: 'beneficiary.Applying_to_Level_Year__c',
        }, {
            Header: 'Email Address',
            accessor: 'Email__c',
        }],
    }, {
        Header: 'Household Information',
        columns: [{
            Header: 'No of Household Member',
            accessor: 'Total_number_of_household_members__c',
        }, {
            Header: 'Mthly Gross Income',
            accessor: 'Monthly_Gross_Income__c',
        }, {
            Header: 'Gross Income per Capita',
            // Cell: cell => (cell.row.Monthly_Gross_Income__c / cell.row.Total_number_of_household_members__c).toFixed(2),
            accessor: 'Monthly_Gross_Per_Capita_Income__c',
        }, {
            Header: 'Remarks',
            accessor: 'Remarks__c',
        }],
    }];
}

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/BeneUpload/actions.js
// module id = 1002
// module chunks = 0